import { HttpEvent, HttpRequest, HttpHandlerFn, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';

import { ApiHttpError, isApiHttpError } from '@app/interfaces/api-error.interface';

export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse | ErrorEvent) => {
      // Log the error for debugging purposes
      console.log(error);

      // Declare an ApiHttpError object to store error information
      let err: ApiHttpError;

      // Determine if the error is a client side or server side error
      if (error instanceof ErrorEvent) {
        // this is client side error
        err = {
          message: error.message,
          error: error.error,
          statusCode: error.NONE,
        };
      } else {
        // this is server side error
        err = isApiHttpError(error.error)
          ? error.error
          : {
              message:
                error.status == 0 ? 'No connection to the server' : error.error?.error_description || error.message,
              error: error.error?.error || error.name,
              statusCode: error.status,
            };
      }

      // Throw the error to be caught by the application's error handler
      return throwError(() => err);
    }),
  );
};
